module.exports = __webpack_public_path__ + "assets/static/png/masterverified.9383f89bcd8c13dad271417f692f8f81.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameFooter/images/masterverified.png
 ** module id = 481
 ** module chunks = 1
 **/